namespace Matrix.Data.Repositories {
    export interface TestGroupRunRequest extends Serenity.ServiceRequest {
        TestGroupCode?: string;
    }
}
